/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Support component names relative to this directory:
import '@babel/polyfill';

var componentRequireContext = require.context('components', true);
var ReactRailsUJS = require('react_ujs');
ReactRailsUJS.useContext(componentRequireContext);

const STORAGE_KEY = 'sl-theme';

function applyTheme(theme) {
  const nextTheme = theme === 'dark' ? 'dark' : 'light';
  document.documentElement.setAttribute('data-theme', nextTheme);

  const toggle = document.querySelector('[data-theme-toggle]');
  if(toggle) {
    toggle.textContent = nextTheme === 'dark' ? 'Light Mode' : 'Dark Mode';
    toggle.setAttribute('aria-pressed', nextTheme === 'dark' ? 'true' : 'false');
  }
}

function preferredTheme() {
  const storedTheme = window.localStorage.getItem(STORAGE_KEY);
  if(storedTheme === 'light' || storedTheme === 'dark') {
    return storedTheme;
  }

  return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
}

function initializeThemeToggle() {
  applyTheme(preferredTheme());

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-theme-toggle]');
    if(!toggle) return;

    const currentTheme = document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    const nextTheme = currentTheme === 'dark' ? 'light' : 'dark';
    window.localStorage.setItem(STORAGE_KEY, nextTheme);
    applyTheme(nextTheme);
  });
}

if(document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeThemeToggle);
} else {
  initializeThemeToggle();
}


function initializeRevealAnimations() {
  const items = Array.from(document.querySelectorAll('[data-reveal]'));
  if(items.length === 0) return;

  if(typeof IntersectionObserver === 'undefined') {
    items.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if(entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.16,
    rootMargin: '0px 0px -8% 0px'
  });

  items.forEach((item, index) => {
    item.style.transitionDelay = Math.min(index * 60, 240) + 'ms';
    observer.observe(item);
  });
}

function initializePublicMotionUi() {
  document.documentElement.classList.add('js-ui-ready');
  initializeRevealAnimations();
}

if(document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializePublicMotionUi);
} else {
  initializePublicMotionUi();
}
